/* ================================
   SEOULSKIN PRODUCT SLIDER LOGIC
   (Adapted from collection slider)
================================ */

class ProductSlider {
  constructor() {
    this.concernsData = {};
    this.init();
  }

  init() {
    // Wait for jQuery and Slick to load
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(() => this.init(), 100);
      return;
    }
    console.log('Product Slider initialized');
  }

  /* ---------------------------
     CENTER ACTIVE TAB ON CLICK
  ----------------------------*/
  scrollTabIntoCenter(btn, container) {
    const btnRect = btn.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const offset = btnRect.left - containerRect.left 
                 - (containerRect.width / 2) 
                 + (btnRect.width / 2);

    container.scrollBy({
      left: offset,
      behavior: "smooth"
    });
  }

  /* ---------------------------
     INIT SLICK SLIDER
  ----------------------------*/
  initSlider(selector) {
    const $el = jQuery(selector);
    if (!$el.length) return;

    if ($el.hasClass('slick-initialized')) {
      $el.slick('unslick');
    }

    $el.slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: false,
      autoplay: false,
      arrows: true,
      dots: true,
      centerMode: false,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: true,
            centerMode: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            centerMode: false
          }
        }
      ]
    });
  }

  /* ---------------------------
     RENDER PRODUCTS BY CONCERN
  ----------------------------*/
  renderProductSliders(productsByPriority) {
    const tabsContainer = document.getElementById('concern-tabs');
    const slidersContainer = document.getElementById('concern-sliders');

    if (!tabsContainer || !slidersContainer) return;

    // Store for later (bundle summary, buy now)
    this.productsByPriority = productsByPriority;

    // Clear loading state
    tabsContainer.innerHTML = '';
    slidersContainer.innerHTML = '';

    const concerns = Object.keys(productsByPriority);
    
    if (concerns.length === 0) {
      slidersContainer.innerHTML = '<p style="text-align: center; padding: 2rem;">No products found for your concerns.</p>';
      return;
    }

    // Create tabs
    concerns.forEach((concern, index) => {
      const products = productsByPriority[concern];
      if (!products || products.length === 0) return;

      // Create tab button
      const tabBtn = document.createElement('button');
      tabBtn.className = `collection-tab-btn ${index === 0 ? 'active' : ''}`;
      tabBtn.dataset.target = `slider-${concern}`;
      tabBtn.textContent = this.formatConcernName(concern);
      tabsContainer.appendChild(tabBtn);

      // Create slider wrapper
      const sliderWrapper = document.createElement('div');
      sliderWrapper.id = `slider-${concern}`;
      sliderWrapper.className = `product-slider-wrapper hh-slider-group ${index !== 0 ? 'hh-slider-hidden' : ''}`;

      const sliderInner = document.createElement('div');
      sliderInner.className = 'product-slider-unique';

      // Add products to slider
      products.forEach(product => {
        const slide = this.createProductSlide(product);
        sliderInner.appendChild(slide);
      });

      sliderWrapper.appendChild(sliderInner);
      slidersContainer.appendChild(sliderWrapper);
    });

    // Initialize first slider
    setTimeout(() => {
      this.initSlider('.hh-slider-group:not(.hh-slider-hidden) .product-slider-unique');
      this.setupTabSwitching();
      this.updateBundleSummary(this.getActiveProducts());
      
      // Initialize Ryviu widgets after slider is ready
      setTimeout(() => {
        if (window.Ryviu && window.Ryviu.initWidget) {
          console.log('[Slider] Initializing Ryviu widgets...');
          window.Ryviu.initWidget();
        }
      }, 500);
    }, 100);
  }

  /* ---------------------------
     CREATE PRODUCT SLIDE HTML
     EXACT copy of byb-product-card.liquid structure
  ----------------------------*/
  createProductSlide(product) {
    const slide = document.createElement('div');
    slide.className = 'product-slide';

    // Calculate on_sale (matches Liquid logic)
    const priceInCents = Math.round(product.price * 100);
    const compareAtPriceInCents = product.compareAtPrice ? Math.round(product.compareAtPrice * 100) : null;
    const onSale = compareAtPriceInCents && compareAtPriceInCents > priceInCents;
    
    // Check availability
    const isAvailable = product.available !== false;
    
    // Check for custom labels in tags (matches Liquid logic: _label_)
    let hasCustomLabel = false;
    let customLabel = '';
    if (product.tags) {
      const tagsArray = Array.isArray(product.tags) ? product.tags : product.tags.split(',').map(t => t.trim());
      for (const tag of tagsArray) {
        if (tag.includes('_label_') && tag.startsWith('_')) {
          hasCustomLabel = true;
          customLabel = tag.replace('_label_', '');
          break;
        }
      }
    }
    
    // Get image URL - use original Shopify URL (try multiple fields)
    let imgUrl = product.image
      || product.featured_image
      || (product.images && product.images.length > 0
          ? (typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || product.images[0]))
          : '');

    // Normalize the image URL (ensure it's absolute)
    if (imgUrl) {
      imgUrl = this.normalizeImageUrl(imgUrl);
    }

    // Debug image URL
    console.log(`[Slider] Product: ${product.title}`, {
      rawImage: product.image,
      featured_image: product.featured_image,
      images: product.images,
      normalizedImgUrl: imgUrl,
      hasImage: !!imgUrl
    });

    // If no image, use placeholder
    if (!imgUrl) {
      console.warn(`[Slider] No image URL for ${product.title}, using placeholder`);
      imgUrl = 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
    }
    
    // Calculate savings amount (₹) instead of percentage
    let savedAmount = '';
    if (onSale && compareAtPriceInCents) {
      const savedInCents = compareAtPriceInCents - priceInCents;
      const savedInRupees = savedInCents / 100;
      savedAmount = `₹${savedInRupees.toFixed(2)}`;
    }

    // Build HTML matching EXACT byb-product-card.liquid structure
    slide.innerHTML = `
      <div class="byb-card"
        data-product-id="${product.id || ''}"
        data-variant-id="${product.variantId || ''}"
        data-product-title="${this.escapeHtml(product.title || '')}"
        data-product-image="${imgUrl}"
        data-mrp="${product.compareAtPrice || product.price}">
        
        <div class="grid-product__content">
          
          ${hasCustomLabel ? `
            <div class="grid-product__tag grid-product__tag--custom">
              ${customLabel}
            </div>
          ` : (!isAvailable ? `
            <div class="grid-product__tag grid-product__tag--sold-out">
              Sold Out
            </div>
          ` : (onSale ? `
            <div class="grid-product__tag grid-product__tag--sale">
              Sale
            </div>
          ` : ''))}
          
          <!-- IMAGE CLICKABLE ONLY -->
          <a href="${product.url || '#'}" class="grid-product__link">
            <div class="grid-product__image-mask">
              
              <div class="grid__image-ratio grid__image-ratio--square">
                <img src="${imgUrl}"
                     alt="${this.escapeHtml(product.title || '')}"
                     loading="lazy"
                     style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"
                     onerror="console.error('Image failed to load:', this.src); this.onerror=null; this.src='https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';">
              </div>
              
            </div>
          </a>
          
          <!-- META SECTION OUTSIDE THE <a> -->
          <div class="grid-product__meta">
            
            <div class="grid-product__title">
              ${product.title || ''}
            </div>
            
            <!-- PRICE BLOCK -->
            <div class="grid-product__price">
              
              ${onSale ? `
                <span class="grid-product__price--original">
                  ${this.formatPrice(product.compareAtPrice)}
                </span>
              ` : ''}
              
              <span class="grid-product__price--current">
                ${this.formatPrice(product.price)}
              </span>
              
              ${onSale && savedAmount ? `
                <span class="grid-product__price--savings">
                  Save ${savedAmount}
                </span>
              ` : ''}
              
            </div>
            
            <!-- 🎯 THEME BUTTON STYLE — BYB LOGIC -->
            <button
              type="button"
              class="btn btn--full btn--secondary byb-toggle-btn"
              data-variant-id="${product.variantId || ''}"
              ${!isAvailable ? 'disabled' : ''}
              ${!isAvailable ? 'style="cursor: not-allowed; opacity: 0.6;"' : ''}>
              ${isAvailable ? 'Add To Box' : 'Sold Out'}
            </button>
            
          </div>
          
        </div>
      </div>
    `;

    return slide;
  }

  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return String(text || '').replace(/[&<>"']/g, m => map[m]);
  }

  /**
   * Normalize Shopify image URL
   * Ensures URL is absolute and properly formatted
   */
  normalizeImageUrl(url) {
    if (!url) return null;
    
    // If already absolute URL, return as-is
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    
    // If relative URL, make it absolute
    if (url.startsWith('//')) {
      return `https:${url}`;
    }
    
    // If starts with /, prepend shop domain
    if (url.startsWith('/')) {
      const shopDomain = window.Shopify?.shop || 'seoulskin.in';
      return `https://${shopDomain}${url}`;
    }
    
    return url;
  }

  /* ---------------------------
     SETUP TAB SWITCHING
  ----------------------------*/
  setupTabSwitching() {
    const tabs = document.querySelectorAll('.collection-tab-btn');
    const tabsContainer = document.querySelector('.collection-tabs');

    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update active state
        tabs.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Auto-scroll tab into center
        this.scrollTabIntoCenter(btn, tabsContainer);

        // Switch slider groups
        const target = btn.dataset.target;
        document.querySelectorAll('.hh-slider-group')
          .forEach(g => g.classList.add('hh-slider-hidden'));

        const activeGroup = document.getElementById(target);
        if (activeGroup) {
          activeGroup.classList.remove('hh-slider-hidden');
          
          // Re-init slider for selected tab
          this.initSlider(`#${target} .product-slider-unique`);

          // Update bundle summary for selected concern
          this.updateBundleSummary(this.getActiveProducts());
        }
      });
    });

    // Auto-center first active tab
    const firstActive = document.querySelector('.collection-tab-btn.active');
    if (firstActive && tabsContainer) {
      this.scrollTabIntoCenter(firstActive, tabsContainer);
    }

    // Bind bulk action buttons
    this.setupBulkButtons();
  }

  /* ---------------------------
     BUNDLE SUMMARY + BULK BUY
  ----------------------------*/
  getActiveProducts() {
    const activeTab = document.querySelector('.collection-tab-btn.active');
    if (!activeTab || !this.productsByPriority) return [];
    const concernKey = activeTab.dataset.target.replace('slider-', '');
    return this.productsByPriority[concernKey] || [];
  }

  updateBundleSummary(products = []) {
    const mrpEl = document.getElementById('bundle-mrp');
    const totalEl = document.getElementById('bundle-total');
    const savingsEl = document.getElementById('bundle-savings');
    if (!mrpEl || !totalEl || !savingsEl) return;

    const topProducts = products.slice(0, 3);

    const total = topProducts.reduce((sum, p) => sum + (p.price || 0), 0);
    const compareTotal = topProducts.reduce((sum, p) => {
      const cap = p.compareAtPrice || p.price || 0;
      return sum + cap;
    }, 0);
    const savings = Math.max(0, compareTotal - total);

    mrpEl.textContent = `MRP: ${this.formatPrice(compareTotal)}`;
    totalEl.textContent = `Now: ${this.formatPrice(total)}`;
    savingsEl.textContent = savings > 0
      ? `You save: ${this.formatPrice(savings)}`
      : 'You save: ₹0.00';
  }

  setupBulkButtons() {
    const addAllBtn = document.getElementById('add-all-items');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', () => {
        const products = this.getActiveProducts();
        // Just add to cart, do NOT redirect to checkout
        this.addBundleToCart(products, { redirectToCheckout: false });
      });
    }
  }

  addBundleToCart(products = [], { redirectToCheckout = false } = {}) {
    if (!products || products.length === 0) {
      alert('No products to add.');
      return;
    }

    const items = [];
    const outOfStock = [];

    products.slice(0, 3).forEach(p => {
      const variantId = p.variantId || p.id;
      if (!variantId) return;
      if (p.available === false) {
        outOfStock.push(p.title || 'Product');
        return;
      }
      items.push({ id: variantId, quantity: 1 });
    });

    if (items.length === 0) {
      alert(outOfStock.length ? 'All selected products are out of stock.' : 'No products to add.');
      return;
    }

    const payload = { items };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to add bundle');
        return res.json();
      })
      .then(() => {
        const skipped = outOfStock.length
          ? `\n\nSkipped ${outOfStock.length} out-of-stock item(s).`
          : '';
        const message = `Added ${items.length} item(s).${skipped}`;

        if (redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        // Try to open cart drawer
        if (typeof theme !== 'undefined' && theme.CartDrawer) {
          try {
            if (!this.cartDrawerInstance) {
              this.cartDrawerInstance = new theme.CartDrawer();
              if (typeof this.cartDrawerInstance.init === 'function') {
                this.cartDrawerInstance.init();
              }
            }
            if (typeof this.cartDrawerInstance.open === 'function') {
              this.cartDrawerInstance.open();
              return;
            }
          } catch (e) {
            console.warn('Cart drawer open failed:', e);
          }
        }

        alert(message);
      })
      .catch(err => {
        console.error('Add bundle error:', err);
        alert('Failed to add products. Please try again.');
      });
  }

  /* ---------------------------
     ADD TO CART
  ----------------------------*/
  addToCart(variantId, quantity) {
    if (typeof jQuery === 'undefined') {
      console.error('jQuery not loaded');
      return;
    }

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { quantity: quantity, id: variantId },
      dataType: "json",
      success: () => {
        // Try to open cart drawer if available
        if (typeof theme !== 'undefined' && theme.CartDrawer) {
          const cart = new theme.CartDrawer();
          cart.init();
          cart.open();
        } else {
          alert('Product added to cart!');
          // Optionally redirect to cart
          // window.location.href = '/cart';
        }
      },
      error: (xhr, status, error) => {
        console.error('Add to cart error:', error);
        alert('Failed to add product to cart. Please try again.');
      }
    });
  }

  /* ---------------------------
     HELPER FUNCTIONS
  ----------------------------*/
  formatConcernName(concern) {
    return concern
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatPrice(price) {
    if (typeof price === 'string') return price;
    return `₹${price.toFixed(2)}`;
  }
}

// Initialize slider when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.productSlider = new ProductSlider();
  });
} else {
  window.productSlider = new ProductSlider();
}

